'use client';

import { useSearchParams } from 'next/navigation';
import { Center, Image, Stack, Text } from '@mantine/core';

export default function SearchNotFound() {
  const searchParams = useSearchParams();
  const params = {
    search: searchParams.get('search'),
    type: searchParams.get('type'),
  };

  return (
    <Center>
      <Stack align="center">
        <Image src="/images/errors/emptyState.svg" alt="Not Found" w={400} />

        <Stack gap={0}>
          {searchParams.get('search') ? (
            <Text ta="center" fw={700} fs="md">
              Oops... {params.type?.toLowerCase() || ''} "
              {searchParams.get('search')}" tidak ditemukan
            </Text>
          ) : (
            <Text ta="center" fw={700} fs="md">
              Oops... {params.type?.toLowerCase() || ''} tidak ditemukan
            </Text>
          )}

          <Text c="dimmed" ta="center" fs="xs">
            Silahkan gunakan kata kunci lain untuk mencari{' '}
            {params.type?.toLowerCase()}
          </Text>
        </Stack>
      </Stack>
    </Center>
  );
}
